module.exports = __webpack_public_path__ + "static/assets/7061adce1a1f16380400243d91d8a3be.svg";